import { reportSystemIssue } from '../api/endpoints/logs';
import { useAuthStore } from '../auth/authStore';

/**
 * Global `window.onerror` / `unhandledrejection` capture → `Logs/ReportSystemIssue`
 * (legacy `Logs/ReportSystemIssue`). Throttled to one report per 30s to avoid storms,
 * only fires for authenticated sessions, and swallows its own failures — the endpoint
 * is UNVERIFIED.
 */
let lastReportAt = 0;
const THROTTLE_MS = 30_000;

function send(errorType: string, message: string) {
  const now = Date.now();
  if (now - lastReportAt < THROTTLE_MS) return;
  if (useAuthStore.getState().status !== 'authenticated') return;
  lastReportAt = now;
  void reportSystemIssue({
    sessionId: useAuthStore.getState().session?.sessionId,
    errorTypes: [errorType],
    errorMessages: [message].filter(Boolean).slice(0, 1),
    pageUrl: window.location.href,
  }).catch(() => undefined);
}

let installed = false;
export function installClientErrorReporter(): void {
  if (installed) return;
  installed = true;
  window.addEventListener('error', (event) => {
    send('window.onerror', event.message || String(event.error));
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    send('unhandledrejection', reason instanceof Error ? reason.message : String(reason));
  });
}
